import Icon from '../../components/Icon.vue'

Icon.register({"regular/credit-card":{"width":576,"height":512,"paths":[{"d":"M527.9 32H48.1C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48.1 480H527.9C554.5 480 576 458.5 576 432V80C576 53.5 554.5 32 527.9 32zM54.1 80H521.9C525.2 80 527.9 82.7 527.9 86V128H48.1V86C48.1 82.7 50.8 80 54.1 80zM521.9 432H54.1C50.8 432 48.1 429.3 48.1 426V256H527.9V426C527.9 429.3 525.2 432 521.9 432zM192 332V372C192 378.6 186.6 384 180 384H108C101.4 384 96 378.6 96 372V332C96 325.4 101.4 320 108 320H180C186.6 320 192 325.4 192 332zM384 332V372C384 378.6 378.6 384 372 384H236C229.4 384 224 378.6 224 372V332C224 325.4 229.4 320 236 320H372C378.6 320 384 325.4 384 332z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/credit-card.js
// module id = 3PoB
// module chunks = 0